import { call, delay, put, take } from '@redux-saga/core/effects';
import ActionTypes from './constants';
import { shelfSelectionClearAction } from 'containers/Configurator/actions/selection';
import { goToStepTutorialAction } from '../TutorialTour/actions';

export default function* switchTabSaga(): any {
  while (true) {
    const { payload } = yield take(ActionTypes.SWITCH_TAB_REQUEST);
    const { tutorial, tutorialCallback } = payload;

    yield put(shelfSelectionClearAction());
    yield delay(500);
    if (tutorial !== undefined) {
      yield put(goToStepTutorialAction(tutorial));
      if (tutorialCallback) {
        yield call(tutorialCallback);
      }
    }
  }
}
